// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"SquareBanner_bannerContainer__KxIe8","banner":"SquareBanner_banner__KYtg2","link":"SquareBanner_link__Yi80m","closeButton":"SquareBanner_closeButton__3tgHJ"};